import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const numeric = (value) => Number(value || 0);
const formatNumber = (value) => numeric(value).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const date = (value) => { const d = new Date(value); return Number.isNaN(d.getTime()) ? '-' : d.toLocaleDateString('en-GB'); };

function documentData({ type, master = {}, details = [], listRow = {} }) {
    const isGRN = type === 'GRN';
    const isPI = type === 'PI';
    const idKey = isPI ? 'piID' : isGRN ? 'pdID' : 'poID';
    const statusKey = isPI ? 'piStatus' : isGRN ? 'pdStatus' : 'poStatus';
    const name = isPI ? 'Purchase Invoice' : isGRN ? 'Goods Receipt Note' : 'Purchase Order';
    const rows = details.map((item, index) => {
        const quantity = numeric(item[isGRN ? 'delivered' : 'quantity'] || item.quantity);
        const rate = numeric(item.itemRate);
        return [index + 1, item.itemDesc || item.itemName || '-', quantity, rate, quantity * rate];
    });
    return {
        name, number: master[idKey] || listRow[idKey] || '-', supplier: listRow.PartyName || master.PartyName || `Supplier #${master.PartyCode || '-'}`,
        date: date(master.entDate || listRow.entDate), status: master[statusKey] || listRow[statusKey] || listRow.deliveryStatus || '-', remarks: master.remarks || listRow.remarks || '-', rows,
        quantity: rows.reduce((total, row) => total + row[2], 0), amount: rows.reduce((total, row) => total + row[4], 0)
    };
}

export function exportPurchaseDocumentExcel(input) {
    const data = documentData(input);
    const sheet = XLSX.utils.aoa_to_sheet([[data.name], ['Document No.', data.number], ['Supplier', data.supplier], ['Date', data.date], ['Status', data.status], ['Remarks', data.remarks], [], ['#', 'Item Description', 'Quantity', 'Rate', 'Amount'], ...data.rows, [], ['', 'Total', data.quantity, '', data.amount]]);
    sheet['!cols'] = [{ wch: 8 }, { wch: 42 }, { wch: 14 }, { wch: 14 }, { wch: 16 }];
    Object.keys(sheet).filter((cell) => /^[C-E]\d+$/.test(cell)).forEach((cell) => {
        sheet[cell].z = '#,##0.00';
    });
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, data.name.slice(0, 31));
    XLSX.writeFile(book, `${data.name.replace(/\s+/g, '_')}_${data.number}.xlsx`);
}

export function exportPurchaseDocumentPDF(input) {
    const data = documentData(input);
    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    doc.setFontSize(18); doc.text(data.name.toUpperCase(), 14, 16);
    doc.setFontSize(10); doc.text(`Document No.: ${data.number}`, 14, 24); doc.text(`Supplier: ${data.supplier}`, 14, 30); doc.text(`Date: ${data.date}`, 14, 36); doc.text(`Status: ${data.status}`, 14, 42);
    autoTable(doc, { startY: 48, head: [['#', 'Item Description', 'Quantity', 'Rate', 'Amount']], body: data.rows.map((row) => [row[0], row[1], formatNumber(row[2]), formatNumber(row[3]), formatNumber(row[4])]), foot: [['', 'Total', formatNumber(data.quantity), '', formatNumber(data.amount)]], theme: 'grid', headStyles: { fillColor: [139, 0, 0] }, footStyles: { fillColor: [255, 196, 0], textColor: [32, 36, 43], fontStyle: 'bold' }, styles: { fontSize: 9 }, columnStyles: { 0: { halign: 'center', cellWidth: 12 }, 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' } } });
    doc.text(`Remarks: ${data.remarks}`, 14, Math.min(doc.lastAutoTable.finalY + 8, 285));
    doc.save(`${data.name.replace(/\s+/g, '_')}_${data.number}.pdf`);
}